class ValidationError extends Error {
    public trace = false;
}

export default ValidationError;
